export const Props = () => ({
  //Ссылка на источник картинки
  src:{
    type: String,
    required: true,
  },

  //Подпись изображения
  alt:{
    type: String,
    default: 'Image',
    required: false,
  },

  //Размер картинки
  size:{
    type: Number,
    default: 32,
  },

  //Блюр картинки (размытость)
  blur:{
    type: Boolean,
    default: false,
  },

  //Толщина обводки
  borderSize:{
    type: Number,
    default: 0,
  },

  //Цвет обводки
  borderColor:{
    type: String,
    default: 'var(--bg-secondary)',
  }
});
